import { fetchData } from './fetchData';
import { FrontVod } from '../data/FrontVod';

type FrontVodRequestData = {
    line_uid: string,
    login: string,
};

/**
 * @description LINE ID與帳號擇一傳入,不可模糊查詢
 */
function frontVod(data: FrontVodRequestData): Promise<FrontVod[]> {
    return fetchData('api/front_vod', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: FrontVod[]) => resData);
}

export { frontVod };
